export const SIZE_MULTIPLIER_MIN = 0.5;
export const SIZE_MULTIPLIER_MAX = 3;
export const SIZE_MULTIPLIER_STEP = 0.1;

// The mobile app toggles bold on every <strong> tag (the same tag opens and closes)
export const BOLD_TAG = "<strong>";

function parseSizeMultiplier(value) {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    const parsedValue = Number(value);

    if (
        Number.isNaN(parsedValue) ||
        parsedValue < SIZE_MULTIPLIER_MIN ||
        parsedValue > SIZE_MULTIPLIER_MAX
    ) {
        return null;
    }

    return parsedValue;
}

// "" means "not set" in the form (the field is not sent to UP Ro)
export function normalizeSizeMultiplier(value) {
    const parsedValue = parseSizeMultiplier(value);

    return parsedValue === null ? "" : parsedValue;
}

export function getPayloadSizeMultiplier(value) {
    return parseSizeMultiplier(value);
}

export function wrapSelectionWithBold(value, selectionStart, selectionEnd) {
    const text = String(value || "");
    const start = Math.max(0, Math.min(selectionStart, selectionEnd));
    const end = Math.max(selectionStart, selectionEnd);

    return {
        value: text.slice(0, start) + BOLD_TAG + text.slice(start, end) + BOLD_TAG + text.slice(end),
        selectionStart: start + BOLD_TAG.length,
        selectionEnd: end + BOLD_TAG.length
    };
}

function escapeHtml(value) {
    return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}

// Escapes the text and renders only the bold markers, so it is safe for v-html
export function formatWidgetTextHtml(value) {
    return String(value || "")
        .split(/<\/?strong>/i)
        .map((part, index) => (index % 2 === 1 ? `<strong>${escapeHtml(part)}</strong>` : escapeHtml(part)))
        .join("");
}
